import React, { PureComponent } from 'react';

import { Grid, Button, Box, withStyles, Avatar } from '@material-ui/core';
import {PersonOutlined, FlagOutlined} from '@material-ui/icons'
import SearcherContainer from '../../containers/SearcherContainer';

import Verify from "./Verify";
import SignIn from "./SignIn";
import SignOut from "./SignOut";
import ChangePassword from './ChangePassword';
import VerifySubmit from './VerifySubmit';
import ResetPassword from './ResetPassword';
import ResetSubmit from './ResetSubmit';

import {states} from './loginConstants';

import { Auth } from "aws-amplify";
import ValidationSnackbar from './ValidationSnackbar';
import Logo from '../Logo';

import {getLabels} from '../../constants/labels';
import {connect} from 'react-redux';
import {searcherActions} from '../../actions/searcher.actionCreators';
import {bindActionCreators} from 'redux';

const styles = theme => ({
    activeButton: {
        textDecoration: 'underline'
    },
    languages: {
        paddingRight:'10px',
        width:'200px'
    },
    avatar: {
        backgroundColor: "#d4e2e9",
        border: `1.7px solid #384257`,
        color:'black',
        width: 22,
        height: 22
      },
    icon: {
        width: 18,
        height: 22,
        stroke: "#d4e2e9",
        strokeWidth: 0.2,
        color:"#384257"
    }
});

/** The following component describes the header of the application */

class Authentication extends PureComponent {
    state = {
        username: "",
        email: "",
        password: "",
        user: null,
        code: "", // Used for email verification
        status: states.PUBLIC,
        oldPassword: "",
        newPassword: "",
        contact: "",
        language: this.props.language || "en"
    }

    resetCredentials() {
        this.setState({
            username: "",
            email: "",
            password: "",
            user: null,
            code: "",
            oldPassword: "",
            newPassword: "",
            contact: "",
            language: this.props.language || "en"
        })
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser()
            .then(data => {
                let user = {username: data.username, ...data.attributes}
                this.setState({user, status: this.state.status === states.PUBLIC ? states.WELCOME : this.state.status});
            })
            .catch(err => console.log(err));
        this.setState({contact: ""});
    }

    handleFormInput = event => {
        this.setState({[event.target.name]: event.target.value})
    }

    setNewPassword = () => {
        const new_password = this.state.newPassword;
        this.setState({password: new_password});
    }

    handleRadio = event => {
        this.setState({contact: event.target.value})
    }

    openSnackbar =  (open, severity, message) => {
        this.setState({open, severity, message})
    }

    /** Manages thr state changes and visualization in different scenarios */
    AuthComponent = () => {
        const { appComponent, logo, language, notifySearchEvent, notifySpanishLanguageEvent, classes, notifyEnglishLanguageEvent } = this.props;
        const labels = getLabels(language);
        const componentProps = {
            switchComponent: this.switchComponent,
            handleFormInput: this.handleFormInput,
            handleRadio: this.handleRadio,
            setNewPassword: this.setNewPassword,
            openSnackbar: this.openSnackbar,
            inputs: this.state,
            language,
            classes
        }
        let loginComponent = null;
        switch (this.state.status) {
            case states.CHANGE_PASSWORD:
                loginComponent = <ChangePassword {...componentProps}/>;
                break;
            case states.VERIFY:
                loginComponent = <Verify {...componentProps}/>;
                break;
            case states.VERIFY_SUBMIT:
                loginComponent = <VerifySubmit {...componentProps}/>;
                break;
            case states.RESET_PASSWORD:
                loginComponent = <ResetPassword {...componentProps}/>;
                break;
            case states.RESET_SUBMIT:
                loginComponent = <ResetSubmit {...componentProps}/>;
                break;
            case states.WELCOME:
                return (<div>
                    <Grid container alignItems="center">
                        <Grid item style={{width: 150, paddingLeft: 20, marginTop: 10}}><Logo/></Grid>
                        <Grid item style={{flexGrow: 1}}>
                            <SearcherContainer
                                signed_user={true}
                                notifySearchEvent={notifySearchEvent}
                            />
                        </Grid>
                        <Box display="flex" flexDirection="row" alignItems="center" style={{paddingRight:'2em'}}>
                            <Avatar className={classes.avatar}>
                                <PersonOutlined className={classes.icon}/>
                            </Avatar>
                            <SignOut {...componentProps}/>
                        </Box>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent='flex-end'
                            xs={1}
                            className={classes.languages}
                        >
                            <Box display="flex" flexDirection="row" alignItems="center">
                                <Avatar className={classes.avatar}>
                                    <FlagOutlined className={classes.icon}/>
                                </Avatar>
                                <Button
                                    color={language === 'es' ? 'primary' : 'default'}
                                    className={language === 'es' ? '' : classes.activeButton}
                                    style={{ textTransform: 'none', minWidth:'48px', fontSize: '13px'}}
                                    onClick={notifyEnglishLanguageEvent()}
                                    >
                                        <b>En</b>
                                </Button>
                                <span>/</span>
                                <Button
                                    color={language === 'es' ? 'default' : 'primary'}
                                    className={language === 'es' ? classes.activeButton : ''}
                                    style={{ textTransform: 'none', minWidth:'48px', fontSize: '13px'}}
                                    onClick={notifySpanishLanguageEvent()}
                                    >
                                        <b>Es</b>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    {appComponent}
                </div>);
            case states.SIGN_IN:
                loginComponent = <SignIn {...componentProps}/>;
                break;
            default: // states.PUBLIC
                return (<div>
                    <Grid container alignItems="center">
                        <Grid item style={{width: 150, paddingLeft: 20, marginTop: 10}}><Logo/></Grid>
                        <Grid item style={{flexGrow: 1}}>
                            <SearcherContainer
                                signed_user={this.state.status === states.WELCOME}
                                notifySearchEvent={notifySearchEvent}
                            />
                        </Grid>
                        
                        <Box display="flex" flexDirection="row" alignItems="center" style={{paddingRight:'2em'}}>
                            <Avatar className={classes.avatar}>
                                <PersonOutlined className={classes.icon}/>
                            </Avatar>
                            <Button
                                size="medium"
                                onClick={() => this.switchComponent(states.SIGN_IN)}
                                style={{textTransform: 'none'}}
                                className={classes.activeButton}
                            >
                                <b>{labels.signIn}</b>
                            </Button>
                        </Box>
                        <Grid
                            item
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent='flex-end'
                            xs={1}
                            className={classes.languages}
                        >
                            <Box display="flex" flexDirection="row" alignItems="center">
                                <Avatar className={classes.avatar}>
                                    <FlagOutlined className={classes.icon}/>
                                </Avatar>
                                <Button
                                    color={language === 'es' ? 'primary' : 'default'}
                                    className={language === 'es' ? '' : classes.activeButton}
                                    style={{ textTransform: 'none', minWidth:'48px', fontSize: '13px'}}
                                    onClick={notifyEnglishLanguageEvent()}
                                >
                                    <b>En</b>
                                </Button>
                                <span>/</span>
                                <Button
                                    color={language === 'es' ? 'default' : 'primary'}
                                    className={language === 'es' ? classes.activeButton : ''}
                                    style={{ textTransform: 'none', fontSize: '13px', minWidth:'48px'}}
                                    onClick={notifySpanishLanguageEvent()}
                                >
                                    <b>Es</b>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>    
                {appComponent}
            </div>);
        }
        return <Grid container direction="column" alignItems="center">
            {logo && <Grid item>{logo}</Grid>}
            <Grid item>{loginComponent}</Grid>
        </Grid>;
    }

    switchComponent = status => {
        this.setState({status});
        if (status === states.SIGN_IN) {
            this.props.actions.setSearchValues([]);
            this.resetCredentials();
        }
    }

    setLanguage= language => {
        if(language!==this.state.language){
            this.setState({language});
        }
        this.props.actions.saveLanguage(language);
        this.resetCredentials();
    }

    render() { // Rendering of the previous component
        const {open, severity, message} = this.state;
        return <>
        <ValidationSnackbar
            open={open}
            severity={severity}
            message={message}
            handleClose={() => this.openSnackbar(false, severity, "")}
        />
        {this.AuthComponent()}
        </>;
    }
}

const mapStateToProps = state => {
    return {
        language: state.languageReducer.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(searcherActions, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Authentication));